import LoginLayout from '@/layouts/Login.vue'
import AppLayout from '@/layouts/Main.vue'

import NotFound from '@/views/NotFound.vue'
import Login from '@/views/Login.vue'
import Recovery from '@/views/Recovery.vue'
import Home from '@/views/Home.vue'
import Profile from '@/views/Profile.vue'
import Users from '@/views/Users.vue'
import Courses from '@/views/Courses.vue'
import Zones from '@/views/Zones.vue'
import PointsOfInterest from '@/views/PointsOfInterest.vue'

export default [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/',
    component: LoginLayout,
    children: [
      {
        path: 'Login',
        name: 'login',
        components: { default: Login }
      },
      {
        path: 'Recovery',
        name: 'recovery',
        components: { default: Recovery }
      }
    ]
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: 'Home',
        name: 'home', /* IF YOU USE Alpha-i18n, please use any existing identifier */
        components: { default: Home }
      },
      {
        path: 'Profile',
        name: 'profile',
        components: { default: Profile }
      },
      {
        path: 'Users',
        name: 'users', /* IF YOU USE Alpha-i18n, please use any existing identifier */
        components: { default: Users }
      },
      {
        path: 'Courses',
        name: 'courses', /* IF YOU USE Alpha-i18n, please use any existing identifier */
        components: { default: Courses }
      },
      {
        path: 'Zones',
        name: 'zones', /* IF YOU USE Alpha-i18n, please use any existing identifier */
        components: { default: Zones }
      },
      {
        path: 'PointsOfInterest',
        name: 'pointsOfInterest', /* IF YOU USE Alpha-i18n, please use any existing identifier */
        components: { default: PointsOfInterest }
      }
    ]
  },
  {
    path: '*',
    component: NotFound
  }
]